import React from 'react';
import hcMark from '../assets/images/hc-mark.png';
import { ReactComponent as PlaneIcon } from '../assets/icons/plane.svg';

// The row's mark, as the embed draws it: a merchant's logo squared off in a grey tile, a
// plane for a travel booking (Access sends no artwork), the school's mark bare for a bonus
// or a purchase without a logo, and the Homecrowd icon on blue when there is no school.
export default function ActivityAvatar({ entry, schoolLogo }) {
  if (entry.logoUrl && (entry.source === 'olive' || entry.source === 'wildfire')) {
    return (
      <span className="home-activity-avatar home-activity-avatar--merchant">
        <img src={entry.logoUrl} alt="" />
      </span>
    );
  }
  if (entry.source === 'travel') {
    return (
      <span className="home-activity-avatar home-activity-avatar--travel" aria-hidden="true">
        <PlaneIcon />
      </span>
    );
  }
  if (schoolLogo) {
    return (
      <span className="home-activity-avatar home-activity-avatar--brand">
        <img src={schoolLogo} alt="" />
      </span>
    );
  }
  return (
    <span className="home-activity-avatar home-activity-avatar--hc">
      <img src={hcMark} alt="" />
    </span>
  );
}
